/* import __COLOCATED_TEMPLATE__ from './row.hbs'; */
var _dec, _class;
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import Component from '@glimmer/component';
import { computed } from '@ember/object';
import { TransferType } from '@square/dashboard-protos/models/squareup/sfs/models/transfer';
let Row = (_dec = computed('args.activity.{transferType,isPending}'), _class = class Row extends Component {
  get textModifierClass() {
    if (this.args.activity.isPending) {
      return 'banking-activity-row__pending-text';
    } else {
      return 'semibold-30';
    }
  }
  get amountTextModifierClass() {
    if (this.args.activity.isPending) {
      return 'banking-activity-row__pending-text';
    } else if (this.args.activity.isVoided) {
      return 'semibold-30 banking-activity-row__voided-text';
    } else {
      return 'semibold-30';
    }
  }
  get disablePendingRow() {
    if (this.args.activity.transferType && this.args.activity.transferType === TransferType.AUTOMATED_SAVINGS) {
      return this.args.activity.isPending;
    } else {
      return false;
    }
  }
}, _applyDecoratedDescriptor(_class.prototype, "disablePendingRow", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "disablePendingRow"), _class.prototype), _class);
export { Row as default };